//Install
import React, { Component } from "react";
//Install
import { ReactComponent as GK48T4 } from "../../../Media/Brand/002.svg";

//Element
class Q901RJ extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "S0u16d C96Q4r vR05U6 d721Vx r4260g" },
            //Element
            React.createElement(GK48T4, {})
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Q901RJ;